import { useEffect, useState } from "react";
import { useParams } from "react-router";
import React from 'react';
import Api from "../../Api/Api";
import { API, username } from "../../API";

import NavBar from "../Navbar";
import axios from "axios";
import { isAutheticated } from "../auth/authhelper";
import { toastError, toastSuccess } from "../../utilis/toast";
import { ToastContainer } from "react-toastify";
import { Link, useHistory, useLocation } from "react-router-dom";


const ChangePassword = (userData) => {
  const { token } = isAutheticated();
  const history = useHistory();

  const [client, setClient] = useState(null);
  const [password, setPassword] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: ""
  });

  // const { username } = useParams();
  useEffect(() => {
    const getData = async () => {
      const { data } = await Api.getClient(username);
      console.log(data);
      setClient(data);
    };
    getData();
  }, [username]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.newPassword !== password.confirmPassword) {
      toastError("Confirm Password is not same")
      return
    }
    try {
      const response = await axios.post(`${API}/api/client/password`, password, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toastSuccess(response?.data?.message)
      return
    } catch (e) {
      toastError(e?.response?.data?.message)
      return
    }
  }

  const handleChange = (e) => {
    setPassword((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value
      }
    })
  }

  console.log(password)
  const handleBack = (e) => {
    history.push(`/profile`);

  };
  return (
    <div className="w-100">
      <NavBar />
      {client && (
        <div className="row mx-3" style={{ position: "absolute", top: "25%", width: "90%" }}>
          {/* <Row>
              <Col md={{ span: 3, offset: 2 }}>
                <img src={client.picture} alt={client.about} />
              </Col>
              <Col md={{ span: 4, offset: 1 }} className="mt-5"> */}
          <div className="col-lg-3 col-md-0 col-sm-0"></div>
          <div className="mx-5 col-lg-5" >
            <form onSubmit={handleSubmit}>
              <div className="form-group mb-2">
                <label for="exampleInputPassword1" className="text-white mb-2">Old Password<span className="text-danger">*</span></label>
                <input type="text" class="form-control" onChange={handleChange} name="oldPassword" value={password.oldPassword} id="exampleInputPassword1" placeholder="old password" />
              </div>
              <div className="form-group mb-2">
                <label for="exampleInputPassword2" className="text-white mb-2">New Password<span className="text-danger">*</span></label>
                <input type="text" class="form-control" onChange={handleChange} name="newPassword" value={password.newPassword} id="exampleInputPassword1" placeholder="new password" />
              </div>
              <div className="form-group mb-4">
                <label for="exampleInputPassword3" className="text-white mb-2">Confirm Password<span className="text-danger">*</span></label>
                <input type="text" class="form-control" onChange={handleChange} name="confirmPassword" value={password.confirmPassword} id="exampleInputPassword1" placeholder="new password" />
              </div>
              <div className="d-flex justify-content-center gap-3">
                <button onClick={(e) => handleBack(e)} className="btn btn-secondary">Back</button>
                <button type="submit" className="btn btn-primary">Submit</button>
              </div>
              {/* <h3
                className="text-white mb-3"
                style={{ textShadow: "1px 1px 1px black" }}
              >
                <span className="text-info">Name: </span>&nbsp; {client.firstName} {client.lastName}
              </h3>
              <h5
                className="text-white mb-3"
                style={{ textShadow: "1px 1px 1px black" }}><span className="text-info">Email:</span> &nbsp;&nbsp;{client.email}</h5>
              {client.username && (
                <p
                  className="text-white-50"
                  style={{ textShadow: "1px 1px 1px black" }}
                >
                  <span className="text-info">Username:</span>&nbsp;&nbsp; {client.username}
                </p>
              )} */}
            </form>
          </div>
          {/* </Col> */}
          {/* </Row> */}
        </div>
      )
      }
      <ToastContainer position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};
export default ChangePassword;
